<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="last60Days"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">URL</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #lead="{ row }">{{ row[1].lead }}</template>
        <template #lost="{ row }">{{ row[1].lost }}</template>
        <template #spam="{ row }">{{ row[1].spam }}</template>
        <template #double_request="{ row }">{{ row[1].double_request }}</template>
        <template #no_response="{ row }">{{ row[1].no_response }}</template>
        <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { getLeadsAnalyticsUrls } from '@/http'
export default {
  name: 'CRMAnalyticsURLs',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      table: {
        items: [],
        columns: ['index', 'name', 'count', 'lead', 'lost', 'spam', 'double_request', 'no_response', 'pre_confirmed', 'confirmed', 'conversion', 'amount', 'commission'],
        options: {
          headings: {
            'index': '#',
            'name': 'URL',
            'count': 'Count',
            'lead': 'Lead',
            'lost': 'Lost',
            'spam': 'Spam',
            'double_request': 'DR',
            'no_response': 'NR',
            'pre_confirmed': 'Pre confirmed',
            'confirmed': 'Confirmed',
            'conversion': 'Conversion',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchItems()
      })
    }, 0)
  },
  methods: {
    fetchItems() {
      getLeadsAnalyticsUrls({from_date: this.filter_dates.start, to_date: this.filter_dates.end})
        .then(response => {
          this.table.items = Object.entries(response.data.instances)
          this.is_loaded = true
        })
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
  }
}
</script>
